import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18e69bdd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-load-wrapper" }
const _hoisted_2 = { class: "d-load-wrapper__top" }
const _hoisted_3 = { class: "d-load-wrapper__bottom" }
const _hoisted_4 = { class: "d-app-progress" }
const _hoisted_5 = { class: "d-app-progress__bar bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$localize('upload.media.stripe.progress')), 1),
      _createElementVNode("small", null, _toDisplayString(_ctx.uploadInfo.counter) + " " + _toDisplayString(_ctx.$localize('upload.of.stripe.progress')) + " " + _toDisplayString(_ctx.uploadInfo.total), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            style: _normalizeStyle('width: ' + _ctx.percentage + '%'),
            class: "bar__item"
          }, null, 4)
        ])
      ])
    ])
  ]))
}